var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{attrs:{"data":_vm.logList}},[_c('el-table-column',{attrs:{"prop":"msg","label":"操作内容"}}),_c('el-table-column',{attrs:{"prop":"created_at","label":"操作时间","width":"160"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }